/**
 * 引取新規登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/pickups`

const orders_accepts_pickups = {
  namespaced: true,
  actions: {
    /**
    * 新規登録初期データの取得
    */
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 複写で利用
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    duplicate ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/duplicate/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
    * 新規登録
    * @param commit
    * @param params
    * @return {Promise<unknown>}
    */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
    * 更新
    * @param commit
    * @param params
    * @return {Promise<unknown>}
    */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    delete ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.delete(api_path).then( data => {
          let result = data.result
          if (result.code !== 409001) {
            commit('snackbar/showInfo', { message: 'キャンセルしました' }, { root: true })
          }
          resolve(result)
        } )
      })
    },
  },
}
export default orders_accepts_pickups
